import { NUMERO_APOSTA_CHANGED, NUMERO_APOSTA_CLEAR, NUMERO_APOSTA_ADD, NUMERO_APOSTA_CLEAR_ALL} from './modalidadeInputAction'

const INITIAL_STATE = { numeroAposta: '', arrNumerosAposta: []}

export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case NUMERO_APOSTA_CHANGED:
            return {...state, numeroAposta: action.payload}
        case NUMERO_APOSTA_CLEAR:
            return {...state, numeroAposta: ''}
        case NUMERO_APOSTA_ADD:
            return {...state, arrNumerosAposta: action.payload}
        case NUMERO_APOSTA_CLEAR_ALL:
            return {...state, arrNumerosAposta: []}
        default:
            return state   

    }
}


// WEBPACK FOOTER //
// ./src/reducers/modalidade/modalidadeInputReducer.js